export default __webpack_public_path__ + "static/media/landing-hitting-views.6bc471b5.png";